export class WalletNetworkChangRejectedException extends Error {
  constructor(message: string) {
    super(message);
  }
}
